import PropType from 'prop-types';
import React, { useRef } from 'react';

export function EditableText({ input, placeholder, getInput }) {
  const [value, setValue] = React.useState(input || '');
  const inputRef = useRef();

  const keypressHandler = event => {
    if (event.key === 'Enter') inputRef.current.blur();
  };

  const handleBlur = () => getInput(value);

  return (
    <input
      onBlur={handleBlur}
      onChange={e => setValue(e.target.value)}
      onKeyPress={keypressHandler}
      placeholder={placeholder}
      ref={inputRef}
      type="text"
      value={value}
    />
  );
}

EditableText.propTypes = {
  input: PropType.string.isRequired,
  placeholder: PropType.string,
  getInput: PropType.func.isRequired
};

EditableText.defaultProps = {
  placeholder: null
};

export default EditableText;
